import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { SCREEN } from 'scenes/common/types/screen';
import { Banner } from 'components/chroma';
import { SubmitButton } from 'components';
import { useForm } from 'react-hook-form';

const Wrapper = styled.div`
  margin-top: 60px;

  @media (min-width: ${SCREEN.SMALL}px) {
    margin-top: 95px;
    text-align: left;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 40px;
`;

export const ErrorPage: FunctionComponent<{
  Content: FunctionComponent;
  Header: FunctionComponent;
  Image: FunctionComponent;
  showNewQuote: boolean;
  onRestartQuote: () => void;
}> = ({ Content, Header, Image, showNewQuote, onRestartQuote }) => {
  const { handleSubmit } = useForm({
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(onRestartQuote)}>
      <Banner width="viewport" padding={0}>
        <Image />
      </Banner>
      <Wrapper>
        <Header />
        <Content />
        {showNewQuote && (
          <ButtonWrapper>
            <SubmitButton enabled>Start a new quote</SubmitButton>
          </ButtonWrapper>
        )}
      </Wrapper>
    </form>
  );
};

export default ErrorPage;
